<script setup>
// import {reactive} from 'vue'
import { defineComponent, ref, toRaw, nextTick } from "vue";
import { useCounterStore } from "@/store/counter/useCounterStore.js";
import { More, ArrowRight, Close } from "@element-plus/icons-vue";
import routes from "@/router/routes.js";
import { useRoute, useRouter } from "vue-router";
const router = useRouter();
const route = useRoute();
const curRouter = ref("");

nextTick(() => {
setTimeout(() => {  
    curRouter.value = route.fullPath;
  }, 300);
  
});
// 是否显示全屏菜单
const showSreen = ref(false);
const goPage = (menu, isShow) => {
  router.push(menu);
  curRouter.value = menu.path;
  if (isShow) showSreen.value = false;
};
// 获取屏幕尺寸
const showMune = ref(window.outerWidth > 1024);
</script>

<template>
  <div class="header">
    <div class="header-top">
      <div class="header__logo" data-aos="zoom-in"></div>
      <ul class="header__nav" data-aos="fade-down" v-show="showMune">
        <li
          class="ballon"
          :class="[curRouter == menu.path ? 'header__nav--active' : '']"
          v-for="menu in routes"
          @click="goPage(menu)"
        >
          {{ menu.name }}
        </li>
      </ul>
      <div v-show="!showMune" class="mune-icon">
        <el-icon @click="showSreen = true" v-show="!showSreen">
          <More />
        </el-icon>
        <el-icon @click="showSreen = false" v-show="showSreen">
          <Close />
        </el-icon>
      </div>
    </div>
    <div
      class="sreen-box"
      v-if="showSreen"
      data-aos="zoom-out-down"
      data-aos-anchor="top-center"
      data-aos-easing="111"
    >
      <div class="header__vertical" data-aos="fade-down">
        <div
          class="mune-item"
          :class="[curRouter == menu.path ? 'header__vertical--active' : '']"
          v-for="menu in routes"
          @click="goPage(menu, true)"
        >
          <div class="mune-item-title">
            {{ menu.name }}
          </div>
          <div>
            <el-icon><ArrowRight /></el-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.header {
  position: absolute;
  top: 0;

  width: calc(100vw - 17px);
  box-sizing: border-box;
  z-index: 1;
}
.header-top {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 10rem;
  z-index: 1000;
  box-sizing: border-box;
  background: linear-gradient(rgba(255, 255, 255, 0.726), #ffffff00);
}
.header__logo {
  width: 190px;
  height: 70px;
  background: url(~static/img/logo.png) no-repeat center center;
  background-size: 100% 100%;
}
.header__nav li.header__nav--active {
  font-weight: bold;
}
.header__nav {
  float: right;
  overflow: hidden;
}
.header__nav li {
  float: left;
  margin: 0 30px;
  font-size: 16px;
  font-weight: 300;
  cursor: pointer;
  color: #333;
  list-style-type: none;
}
.ballon {
  transition: all 0.4s;
}
.ballon:hover {
  transform: scale(1.1);
}
.aos-animate {
  transition-delay: 0.2s;

  opacity: 1;
  transform: translateZ(0);
}
.mune-icon {
  position: absolute;
  right: 5vw;
  width: 5vw;
  height: 5vw;
  line-height: 0;
  text-align: center;
}
.sreen-box {
  height: 100vh;
  width: calc(100% - 0vw);
  background: #ffffffc9;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1002;
  padding: 18vw 5vw 0 5vw;
  box-sizing: border-box;
}
.header__vertical {
  .mune-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ffffffb8;
    padding: 0 1vw;
    color: #0670b9;
    .mune-item-title {
      font-size: 4vw;
      font-weight: 300;
      cursor: pointer;
      color: #333;
      line-height: 15vw;
    }
    .mune-item-title:hover {
      font-weight: bold;
    }
  }
}

@media screen and (max-width: 1600px) {
  .header-top {
    padding: 0 3rem;
  }
}
@media screen and (max-width: 1024px) {
  .header {
    width: 100%;
    .header-top {
      box-sizing: border-box;
      padding: 1rem 1rem 0 1rem;
      width: calc(100% - 1rem);

      // position: relative;
      // .header__nav {
      //   float: left;
      //   padding-left: 0;
      // }
    }
  }
}
</style>
